// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
var QuestionPopover = require("../../../components/MyClientsWidget/components/QuestionPopover/QuestionPopover.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardRelayKeyFactsPrice_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPrice_draft_graphql.bs.js");
var PropertyWizardRelay__KeyFacts__Price__ExactPrice = require("./PropertyWizardRelay__KeyFacts__Price__ExactPrice.bs.js");
var PropertyWizardRelay__KeyFacts__Price__PriceRange = require("./PropertyWizardRelay__KeyFacts__Price__PriceRange.bs.js");
var PropertyWizardFormRelay__Validators__KeyFacts__Price = require("./PropertyWizardFormRelay__Validators__KeyFacts__Price.bs.js");

var convertFragment = PropertyWizardRelayKeyFactsPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPrice_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPrice_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPrice_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__Price(props) {
  var stepHasBeenTouched = props.stepHasBeenTouched;
  var draft = use(props.draft);
  var update = PropertyWizardFormRelay.useUpdateDraftProperty();
  var match = draft.draftProperty;
  var priceRange = match.priceRange;
  var commission = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (current, value) {
            var newrecord = Caml_obj.obj_dup(current);
            newrecord.commission = value;
            return newrecord;
          })
      }, stepHasBeenTouched, match.commission, undefined);
  var price = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (current, value) {
            var newrecord = Caml_obj.obj_dup(current);
            newrecord.price = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draft.draftProperty.price, PropertyWizardFormRelay__Validators__KeyFacts__Price.ExactPrice.useIsValid(draft.fragmentRefs));
  var minPrice = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.minPrice = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draft.draftProperty.minPrice, PropertyWizardFormRelay__Validators__KeyFacts__Price.MinPrice.useIsValid(draft.fragmentRefs));
  var maxPrice = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.maxPrice = value;
            return newrecord;
          })
      }, stepHasBeenTouched, draft.draftProperty.maxPrice, PropertyWizardFormRelay__Validators__KeyFacts__Price.MaxPrice.useIsValid(draft.fragmentRefs));
  var minPriceOrMaxPriceFocused = minPrice.focused || maxPrice.focused;
  var match$1 = price.focused;
  var match$2 = draft.draftProperty.propertyType;
  var tmp;
  tmp = match$2 === "FOR_SALE" ? JsxRuntime.jsxs(CssGrid.Cell, {
          width: 12,
          widthMd: 6,
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Form__Label.make, {
                                  labelText: "Concessions seller will consider",
                                  optionalText: "Optional",
                                  htmlFor: "concessions"
                                }),
                            JsxRuntime.jsx(QuestionPopover.make, {
                                  children: "Not binding on the seller unless confirmed by separate agreement among applicable parties."
                                })
                          ],
                          className: "flex gap-2 items-start"
                        }),
                    JsxRuntime.jsx(Form__Input.make, {
                          onChange: (function ($$event) {
                              var text = $$event.currentTarget.value;
                              commission.onChange(PropertyWizardRelayUtils.FormUtils.noneIfEmpty(text));
                            }),
                          onBlur: (function (param) {
                              commission.onBlur();
                            }),
                          status: commission.status,
                          value: commission.valueAsString,
                          id: "concessions"
                        })
                  ]
                }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
                  valid: commission.valid
                })
          ]
        }) : null;
  return JsxRuntime.jsx(FormV5.FormSection.make, {
              tipbox: match$1 ? Caml_option.some(TipBoxes.PropertyWizard.price) : (
                  minPriceOrMaxPriceFocused ? Caml_option.some(TipBoxes.PropertyWizard.priceRange) : undefined
                ),
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs(CssGrid.Grid, {
                            children: [
                              priceRange ? JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__Price__PriceRange.make, {
                                      draft: draft.fragmentRefs,
                                      minPrice: minPrice,
                                      maxPrice: maxPrice
                                    }) : JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__Price__ExactPrice.make, {
                                      draft: draft.fragmentRefs,
                                      price: price
                                    }),
                              JsxRuntime.jsx(CssGrid.Cell, {
                                    width: 12,
                                    children: Caml_option.some(JsxRuntime.jsx(ViewStack.make, {
                                              flexDirection: "column",
                                              children: Caml_option.some(JsxRuntime.jsx(Form__Checkbox.make, {
                                                        onChange: (function (_e) {
                                                            update(function (c) {
                                                                  var newrecord = Caml_obj.obj_dup(c);
                                                                  newrecord.priceRange = !priceRange;
                                                                  return newrecord;
                                                                });
                                                          }),
                                                        name: "priceRange",
                                                        checked: priceRange,
                                                        label: "Or enter a price range instead"
                                                      }))
                                            }))
                                  })
                            ]
                          }),
                      JsxRuntime.jsx(CssGrid.Grid, {
                            children: Caml_option.some(tmp)
                          })
                    ],
                    className: "space-y-10"
                  })
            });
}

var Components;

var FormSection;

var Checkbox;

var Grid;

var Cell;

var TextInputField;

var TipBoxes$1;

var ExactPrice;

var PriceRange;

var Validators;

var FormUtils;

var make = PropertyWizardRelay__KeyFacts__Price;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Checkbox = Checkbox;
exports.Grid = Grid;
exports.Cell = Cell;
exports.TextInputField = TextInputField;
exports.TipBoxes = TipBoxes$1;
exports.ExactPrice = ExactPrice;
exports.PriceRange = PriceRange;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
